import {
  JobsConfigurationCommand,
  JobsConfigurationJob
} from "modules/system/sections/plt/field-management/rings/rollout-package/configure/jobs/dtos";
import { useRolloutPackage } from "modules/system/sections/plt/field-management/rings/rollout-package/context/rollout-package-context";

import { QueryStateIndicator } from "@components/QueryStateIndicator";
import { useSoftwarePackageCommandJson } from "@libs/api/gateways/field/field-ops-gateway.hooks";

import { CommandDialog, CommandDialogProps } from "./CommandDialog";
import { CommandForm } from "./CommandForm";

interface CommandEditHostProps extends CommandDialogProps {
  job: JobsConfigurationJob;
  command?: JobsConfigurationCommand;
  onUpdate: (
    command: JobsConfigurationCommand,
    job: JobsConfigurationJob
  ) => void;
}

export const CommandEditHost: React.FC<CommandEditHostProps> = ({
  job,
  command,
  onUpdate,
  onDismiss,
  ...props
}) => {
  const { softwarePackageVersionId } = useRolloutPackage();

  const softwarePackageCommandsQuery = useSoftwarePackageCommandJson(
    softwarePackageVersionId
  );

  const { isLoading } = softwarePackageCommandsQuery;
  return (
    <CommandDialog onDismiss={onDismiss} {...props}>
      <QueryStateIndicator {...softwarePackageCommandsQuery}>
        {schemas => {
          return (
            <CommandForm
              schemas={schemas}
              job={job}
              command={command}
              isLoading={isLoading}
              onDismiss={e => onDismiss?.(e)}
              onUpdate={onUpdate}
            />
          );
        }}
      </QueryStateIndicator>
    </CommandDialog>
  );
};
